import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "relative relative-box pl-4 py-4"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "copy-icon"
};
const _hoisted_4 = {
  key: 0,
  class: "absolute top-0 right-0 w-full h-full",
  "element-loading-text": "美化中..."
};
import { ElMessage } from 'element-plus';
import { ref, watch, onMounted, onUnmounted, nextTick } from 'vue';
import { promiseTimeout } from '@vueuse/core';
import { typewriterEffect, copy } from '@utils/window-helpers';
import { renderMarkdown } from '@/utils/markdown';
export default /*@__PURE__*/_defineComponent({
  __name: 'ContentBlock',
  props: {
    content: {},
    isMd: {
      type: Boolean
    },
    markdownRepairs: {
      default: () => []
    },
    isAnimate: {
      type: Boolean
    },
    cusSty: {},
    height: {},
    animateTime: {
      default: 50
    }
  },
  emits: ["animateEnd"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const styleMap = {
      1: 'beautify'
    };
    const scrollRef = ref();
    const cusClass = ref('');
    const loading = ref(false);
    const html = ref('');
    let initHtml = '';
    // 新增滚动状态相关变量
    // const userHasScrolled = ref(false)
    // const isAutoScrolling = ref(false)
    // const scrollThreshold = 80 // 滚动到底部的阈值
    // 新增滚动事件处理
    // const handleScroll = () => {
    //   if (isAutoScrolling.value) {
    //     isAutoScrolling.value = false
    //     return
    //   }
    //   userHasScrolled.value = true
    // }
    // 新增自动滚动条件判断
    // const shouldAutoScroll = () => {
    //   if (!userHasScrolled.value) return true
    //   const { scrollTop, clientHeight, scrollHeight } = scrollRef.value
    //   return scrollTop + clientHeight >= scrollHeight - scrollThreshold
    // }
    const beautifyStyle = async (type, time = 2000) => {
      loading.value = true;
      html.value = initHtml;
      await promiseTimeout(time);
      if (styleMap[type]) cusClass.value = styleMap[type];
      loading.value = false;
    };
    const scrollToTop = () => {
      const elements = scrollRef.value.firstElementChild;
      if (elements) {
        // 使用容器自身的滚动方法
        scrollRef.value.scrollTo({
          top: elements.offsetTop,
          behavior: 'smooth'
        });
      }
    };
    const scrollToBottom = async () => {
      // if (shouldAutoScroll()) {
      // isAutoScrolling.value = true
      await nextTick();
      scrollRef.value.scrollTo({
        top: scrollRef.value.scrollHeight,
        behavior: scrollRef.value.style.scrollBehavior ? 'smooth' : 'auto' // 降级处理
      });
      // }
    };
    let controller = null;
    const setContent = async htmlStr => {
      if (controller) {
        controller.abort();
      }
      if (props.isAnimate) {
        let str = '';
        controller = typewriterEffect(htmlStr, async currentText => {
          str += currentText;
          const doc = new DOMParser().parseFromString(str.replace(/<[^>]*$/g, ''), 'text/html');
          html.value = doc.body.innerHTML;
          scrollToBottom();
        }, async () => {
          controller = null;
          await beautifyStyle(1);
          // if (shouldAutoScroll()) {
          scrollToTop();
          // }
          await promiseTimeout(1000);
          emits('animateEnd');
        }, props.animateTime);
      } else {
        html.value = htmlStr;
      }
    };
    const handleCopy = () => {
      copy(html.value);
      ElMessage.success('复制成功');
    };
    // 添加滚动事件监听
    onMounted(() => {
      if (props.cusSty) {
        cusClass.value = styleMap[props.cusSty];
      }
      // scrollRef.value?.addEventListener('scroll', handleScroll)
    });
    // 移除滚动事件监听
    onUnmounted(() => {
      if (controller) {
        controller.abort();
      }
      // scrollRef.value?.removeEventListener('scroll', handleScroll)
    });
    watch(() => [props.content, props.isMd, props.markdownRepairs], async () => {
      if (!props.content) {
        html.value = '<p>未能获取到相关内容</p>';
        return;
      }
      if (props.isMd) {
        initHtml = renderMarkdown(props.content, props.markdownRepairs);
      } else {
        initHtml = props.content;
      }
      const htmlDoc = new DOMParser().parseFromString(initHtml, 'text/html');
      // 没有内容
      if (!htmlDoc.body.textContent.replace(/\s+/g, '')) {
        if (props.isAnimate) emits('animateEnd');
        return;
      }
      setContent(initHtml);
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      beautifyStyle,
      scrollToBottom,
      scrollToTop,
      getScrollEl: () => {
        return scrollRef.value;
      },
      setLoading: val => {
        loading.value = val;
      },
      setCusClass: val => {
        if (val) {
          cusClass.value = styleMap[val];
        } else {
          cusClass.value = '';
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_copy = _resolveComponent("i-home-copy");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_icon = _resolveComponent("el-icon");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "scrollRef",
        ref: scrollRef,
        class: "content-block",
        style: _normalizeStyle({
          height: props.height
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(["cus-md-minimalist card-content", cusClass.value]),
        innerHTML: html.value
      }, null, 10, _hoisted_2)], 4), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, {
        color: "var(--el-color-primary)",
        onClick: handleCopy
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tooltip, {
          content: "点击复制",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_home_copy)]),
          _: 1
        })]),
        _: 1
      })]), loading.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, null, 512)), [[_directive_loading, true]]) : _createCommentVNode("", true)]);
    };
  }
});